import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08d61e27&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d61e27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d61e27')) {
      api.createRecord('08d61e27', component.options)
    } else {
      api.reload('08d61e27', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08d61e27&scoped=true", function () {
      api.rerender('08d61e27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/specialty/index.vue"
export default component.exports